<template>
  <the-header></the-header>
  <router-view v-slot="slotProps">
    <component :is="slotProps.Component"></component>
  </router-view>
</template>
<script>
import { onMounted } from "vue";
import { useStore } from "vuex";
import socket from "@/socket.js";
export default {
  setup() {
    const store = useStore();
    socket.off();
    onMounted(() =>{
      store.dispatch("auth/attemptLogin");
    });
    store.dispatch('chat/bindEvents');
    store.dispatch('friend/bindEvents');
    socket.auth = {
      token: localStorage.getItem('token')
    }
    socket.connect();
  }
};
</script>